import React from 'react';
import classNames from 'classnames';
import styles from './HeaderPopoverContent.module.scss';
import ShareImage from './images/share.svg';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon,
} from 'react-share';

const SHARE_URL = 'https://insightsoftware.com/embedded-analytics/';
const DEMO_URL = 'https://insightsoftware.com/demo/embedded-analytics';
const PRICING_URL = 'https://insightsoftware.com/request-a-price';

/**
 * Body content for the header “Share” and “Reach out to us” dropdowns.
 * Same layout shell; only the actions differ (social vs demo/pricing).
 */
export default function HeaderPopoverContent({ variant }) {
  if (variant === 'share') {
    return (
      <div className={styles.root}>
        <h2 className={styles.title}>Know someone who would love Embedded Analytics?</h2>
        <div className={styles.contentHolder}>
          <div className={styles.contentLeft}>
            <p className={styles.text}>Tell them or share on social media!</p>
            <div className={styles.actionsRow}>
              <button
                type="button"
                className={styles.actionButton}
                onClick={() => navigator.clipboard.writeText(SHARE_URL)}
              >
                Copy link
              </button>
              <EmailShareButton url={SHARE_URL}>
                <EmailIcon size={32} round />
              </EmailShareButton>
              <FacebookShareButton url={SHARE_URL}>
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <LinkedinShareButton url={SHARE_URL}>
                <LinkedinIcon size={32} round />
              </LinkedinShareButton>
              <TwitterShareButton url={SHARE_URL}>
                <TwitterIcon size={32} round />
              </TwitterShareButton>
            </div>
          </div>
          <div className={styles.contentRight}>
            <img src={ShareImage} alt="" className={styles.shareImg} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>Want to learn more about the product?</h2>
      <div className={styles.contentHolder}>
        <div className={styles.contentLeft}>
          <p className={styles.text}>Get a Demo or Pricing</p>
          <div className={classNames(styles.actionsRow, styles.reachOutActions)}>
            <button
              type="button"
              className={styles.actionButton}
              onClick={() => {
                window.location.href = DEMO_URL;
              }}
            >
              Get a Demo
            </button>
            <button
              type="button"
              className={styles.actionButton}
              onClick={() => {
                window.location.href = PRICING_URL;
              }}
            >
              Get Pricing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
